import { render, staticRenderFns } from "./VTabHead.vue?vue&type=template&id=590882e0&scoped=true&"
import script from "./VTabHead.vue?vue&type=script&lang=js&"
export * from "./VTabHead.vue?vue&type=script&lang=js&"
import style0 from "./VTabHead.vue?vue&type=style&index=0&id=590882e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590882e0",
  null
  
)

export default component.exports